angular.module("screensApp").controller("VideoController", function ($scope, $sce, $rootScope, $timeout) {
  var self = this;
  $scope.API = "";
  self.settings = {
    nativeFullscreen: true,
    loop: false,
    sources: [
      {
        src: $sce.trustAsResourceUrl(""),
        type: "",
      },
    ],
  };

  $rootScope.showVideo = function (data) {
    self.settings.sources = [
      {
        src: $sce.trustAsResourceUrl(data.VideoLink),
        type: data.Type,
      },
    ];
    data = null;
    $timeout(function () {
      $scope.API.play();
    });
    $rootScope.settings.video.show = true;
    $rootScope.$$phase || $rootScope.$apply();
  };

  $rootScope.hideVideo = function () {
    $rootScope.settings.video.show = false;
    $rootScope.$$phase || $rootScope.$apply();
    $scope.API.stop();
    // self.settings.sources =[{
    // 	src: $sce.trustAsResourceUrl(""),
    // 	type: ""
    // }];
  };

  self.onPlayerReady = function ($API) {
    $scope.API = $API;
    $timeout(function () {
      try {
        $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: onPlayerReady()');
        $API.setVolume(1);
      } catch (err) {
        $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR: onPlayerReady() err: ' + err);
      }
    }, 0);
  };

  self.vgComplete = function (e) {
    $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: vgComplete() { video completed }');
    $scope.API.stop();
    $rootScope.settings.video.show = false;
    $rootScope.$$phase || $rootScope.$apply();
  };
});
